import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const Integrations = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.integrations')} />;
};

export default Integrations;
